export const rawFilesToFormData = (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  return formData;
};
